const GridManager = {};

export const MODE_CARD = 'card';
export const MODE_TABLE = 'table';

export default GridManager;



// WEBPACK FOOTER //
// ./src/services/GridManager.js